import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueFieldSchemesConfigRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-schemes',
	path: '/jira/settings/issues/field-schemes',
	exact: true,
};
